let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1cNBX")).then(() => parcelRequire('9Z0w0'));